{
  "more": "Ďalšie položky"
}
